export const UPDATE_VALUE_PROVINCE = 'UPDATE_VALUE_PROVINCE';
export const UPDATE_VALUE_DISTRICT = 'UPDATE_VALUE_DISTRICT';
export const UPDATE_VALUE_WARD = 'UPDATE_VALUE_WARD';
export const PROVINCE = 'PROVINCE';
export const DISTRICT = 'DISTRICT';
export const WARD = 'WARD';
